export default __webpack_public_path__ + "static/media/image.ss-creation-design.63459b54.png";